import React, { useEffect, useState } from 'react'
import { v3_ncr_logs } from '../../../actions/v3/ncr'
import moment from 'moment'

const Log = ({ ncrId }) => {
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [data, setData] = useState({ logs: [], total: 0 })
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)

    useEffect(() => {
        fetchLogs(1, true)
    }, [ncrId, refresh])

    const fetchLogs = async (pageNo, reset = false) => {
        setLoading(true)
        const res = await v3_ncr_logs(pageNo, limit, ncrId)
        if (res.status) {
            const newLogs = res.result.logs
            const uniqueNew = newLogs.filter(
                c => !data.logs.some(existing => existing.ID === c.ID)
            )
            setData(prev => ({
                total: res.result.total,
                logs: reset ? res.result.logs : [...prev.logs, ...uniqueNew],
            }))
            setPage(pageNo)
        }
        setLoading(false)
    }

    const handleLoadMore = () => {
        if (!loading && data.logs.length < data.total) {
            fetchLogs(page + 1)
        }
    }

    return (


        <div className="activity-items">
            {data.logs.length > 0 && (() => {
                let lastDate = null;
                return data.logs.map((item, index) => {
                    const currentDate = moment(item.CREATED_ON).format('MMMM D, YYYY')
                    const showDateHeader = currentDate !== lastDate
                    lastDate = currentDate

                    const initials = item.CREATED_BY_NAME?.split(' ')
                        .map(word => word.charAt(0).toUpperCase())
                        .join('')

                    return (
                        <React.Fragment key={item.ID}>
                            {showDateHeader && (
                                <div className="activity-item-wrap activity-date">
                                    <h4 className="activity-date">{currentDate}</h4>
                                </div>
                            )}

                            <div className="activity-item-wrap activity-call">
                                <div className="activity-item-badge">
                                    <i className="aroicon-action-send-message" />
                                </div>
                                <div className="activity-item">
                                    <div className="activity-item-meta">
                                        <div className="activity-user">{initials}</div>
                                        <p className="activity-summary">
                                            <strong>{item.CREATED_BY_NAME}</strong> {item.REMARK}
                                        </p>
                                        <p className="activity-timestamp">
                                            {moment(item.CREATED_ON).format('MMM D [at] hh:mm a')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                })
            })()}

            {data.logs.length < data.total && (
                <div className="activity-item-wrap activity-date text-center mt-2">
                    <p>
                        <a href="#" onClick={(e) => { e.preventDefault(); handleLoadMore(); }}>
                            {loading ? 'Loading...' : 'Load more activity...'}
                        </a>
                    </p>
                </div>
            )}

        </div>
    )
}

export default Log
